export default () => {
  const timeouts = [];
  const setupListeners = () => {
    (document.querySelectorAll('.notification .delete') || []).forEach(($delete) => {
      const $notification = $delete.parentNode;
      $delete.addEventListener('click', () => {
        $notification.parentNode?.removeChild($notification);
      });
    });
    Array.from(document.querySelectorAll('.live-flash-wrapper .notification, #flash-wrapper .notification')).forEach((el) => {
      timeouts.push(setTimeout(() => {
        el.remove();
      }, el.dataset.timeout ?? 10000));
    });
  };
  setupListeners();
  document.addEventListener('phx:update', () => {
    while (timeouts.length) {
      clearTimeout(timeouts.pop());
    }
    setupListeners();
  });
};
